import {
  GENERIC_ERROR,
  messageFor,
  toFormErrors,
  withoutErrorsFor,
  type FormErrors,
} from '../../lib/formErrors'

/**
 * Which box on the agent form each rejection belongs to. The agent form shares its
 * page with the broker form — both have a phone and an email — but each form keeps
 * its own map, so `phone_invalid` lands on the box of the form that was saved.
 */
const AGENT_FIELD_BY_CODE: Record<string, string> = {
  agent_first_name_required: 'firstName',
  agent_first_name_invalid: 'firstName',
  agent_first_name_too_long: 'firstName',
  agent_last_name_required: 'lastName',
  agent_last_name_invalid: 'lastName',
  agent_last_name_too_long: 'lastName',
  agent_title_too_long: 'title',
  agent_email_required: 'email',
  agent_email_invalid: 'email',
  agent_duplicate_email: 'email',
  agent_phone_required: 'phone',
  phone_invalid: 'phone',
  agent_phone_extension_invalid: 'phoneExtension',
}

/** Nothing on this form is fixed from a box other than its own. */
const AGENT_CLEARED_BY: Record<string, readonly string[]> = {}

export { GENERIC_ERROR, messageFor }
export type { FormErrors }

export const toAgentFormErrors = (caught: unknown): FormErrors =>
  toFormErrors(caught, AGENT_FIELD_BY_CODE)

export const withoutAgentErrorsFor = (errors: FormErrors, editedField: string): FormErrors =>
  withoutErrorsFor(errors, editedField, AGENT_CLEARED_BY)
